import React from 'react';
import { compose, pure } from 'recompose';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DetailTextButton from '../atoms/DetailTextButton';
import EditTextButton from '../atoms/EditTextButton';
import QrCodeTextButton from '../atoms/QrCodeTextButton';
import ResetPassTextButton from '../atoms/ResetPassTextButton';
import ChangeStatusShopTextButton from '../atoms/ChangeStatusShopTextButton';
import ChangeStatusShopShowTextButton from '../atoms/ChangeStatusShopShowTextButton';
import LoginShopTextButton from '../atoms/LoginShopTextButton';
import LinkPaypayButton from '../atoms/LinkPaypayButton';
import paymentTypes, {
  onePayEnabled,
  wechatPayEnabled
} from '../../constants/PaymentTypes';
import LinkOnePayButton from '../atoms/LinkOnePayButton';
import LinkWechatPayButton from '../atoms/LinkWechatPayButton';
import ChangeEmailShopTextButton from '../atoms/ChangeEmailShopTextButton';
import ChangeGochiKidFlagShopTextButton from '../atoms/ChangeGochiKidFlagShopTextButton';
import ChangeGochiKidUnlimitStatus from '../atoms/ChangeGochiKidUnlimitStatus';
import ChangeGochiKidReceipt from '../atoms/ChangeGochiKidReceipt';
import ChangeAllowGapPayment from '../atoms/ChangeAllowGapPayment';

const styles = {};

const enhance = compose(pure);

const ShopTableBody = enhance(
  ({
    shops,
    emptyRows,
    page,
    rowsPerPage,
    detailOpenAction,
    editOpenAction,
    qrCodeAction,
    order,
    orderBy,
    roles,
    resetPasswordAction,
    changeStatusShopAction,
    statusShop,
    setStatusShop,
    message,
    setMessage,
    changeStatusShopShowAction,
    linkPaypayAction,
    unlinkPaypayAction,
    linkOnepayAction,
    unlinkOnepayAction,
    linkWechatPayAction,
    unlinkWechatPayAction,
    searchKey,
    handeOpenSettingUnlimitGochiKidModal,
    handeOpenSettingGochiKidReceiptModal,
    handleOpenChangeAllowGapPaymentModal
  }) => {
    let sortedResult;
    if (orderBy === 'streetAddress') {
      sortedResult = _.orderBy(
        shops,
        ['prefectures', 'city', 'address', 'building'],
        [order, order, order, order]
      );
    } else {
      sortedResult = _.orderBy(shops, orderBy, order);
    }

    const loginToShop = params => {
      let url = `/?cui=${params.cognitoUserId}&lts=true&sn=${encodeURIComponent(
        params.shopName
      )}&sid=${params.shopId}`;

      if (params.groupEducateSystem) {
        url = process.env.REACT_APP_EDUCATION_SYSTEM_MANAGE_WEB + url;
      }

      window.open(url, '_blank');
    };
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(shop => {
            const params = {
              id: shop.shopId,
              shopName: shop.shopName
            };
            const shopInfo = {
              shopId: shop.shopId,
              status: shop.status
            };
            let disabled = true;
            if (
              shop.status === 'AVAILABLE' ||
              shop.status === 'PRE_AVAILABLE' ||
              shop.status === 'SUSPENDED' ||
              shop.status === 'CLOSED'
            ) {
              disabled = false;
            }
            let disabledShow = true;
            if (shop.status === 'AVAILABLE') {
              disabledShow = false;
            }
            let titleStatus = '';
            if (shop.status === 'AVAILABLE') {
              titleStatus = '利用可能';
            } else if (shop.status === 'PRE_AVAILABLE') {
              titleStatus = '準備中';
            } else if (shop.status === 'SUSPENDED') {
              titleStatus = '利用停止中';
            } else if (shop.status === 'CLOSED') {
              titleStatus = '閉店';
            }

            let titleShowStatus = '';
            if (shop.isAllShopEnable === true) {
              titleShowStatus = '全ての法人で表示';
            } else {
              titleShowStatus = '特定の法人のみで表示';
            }

            let titleGochiKidFlag = '';
            if (shop.gochiKidFlag === 0 && shop.gochiKidQrFlag === 0) {
              titleGochiKidFlag = '参加しない';
            } else if (shop.gochiKidFlag === 1 && shop.gochiKidQrFlag === 1) {
              titleGochiKidFlag = '参加する(カード型会員証対応あり)';
            } else if (shop.gochiKidFlag === 1 && shop.gochiKidQrFlag === 0) {
              titleGochiKidFlag = '参加する(カード型会員証対応なし)';
            }

            const key = `${shop.shopId}-${shop.groupId}`;
            return (
              <TableRow key={key}>
                <TableCell>
                  <EditTextButton
                    id={shop.shopId}
                    onClickAction={editOpenAction}
                  />
                </TableCell>
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TableCell>{shop.shopId}</TableCell>
                )}
                {(roles.isGroup ||
                  roles.isSecretariat ||
                  roles.isDeveloper) && <TableCell>{shop.groupName}</TableCell>}
                <TableCell>{shop.shopName}</TableCell>
                <TableCell>
                  {shop.prefectures}
                  {` `}
                  {shop.city}
                  {` `}
                  {shop.address}
                  {` `}
                  {shop.building}
                </TableCell>
                <TableCell>{shop.phone}</TableCell>
                <TableCell>
                  <ChangeEmailShopTextButton
                    shopId={shop.shopId}
                    email={shop.email}
                  />
                </TableCell>
                <TableCell>
                  <DetailTextButton
                    params={params}
                    onClickAction={detailOpenAction}
                  />
                </TableCell>
                {(roles.isGroup ||
                  roles.isSecretariat ||
                  roles.isDeveloper) && (
                  <TableCell>
                    <QrCodeTextButton
                      id={shop.shopId}
                      name={shop.shopName}
                      onClickAction={qrCodeAction}
                    />
                  </TableCell>
                )}
                <TableCell>
                  {roles.isSecretariat && (
                    <ResetPassTextButton
                      params={params}
                      onClickAction={resetPasswordAction}
                    />
                  )}
                </TableCell>
                {roles.isSecretariat && (
                  <TableCell>
                    <ChangeGochiKidFlagShopTextButton
                      shopId={shop.shopId}
                      textButton={titleGochiKidFlag}
                      gochiKidFlag={shop.gochiKidFlag}
                      gochiKidDonateFlag={shop.gochiKidDonateFlag}
                      gochiKidUserUseType={shop.gochiKidUserUseType}
                      gochiKidQrFlag={shop.gochiKidQrFlag}
                      searchKey={searchKey}
                    />
                  </TableCell>
                )}
                {roles.isSecretariat && (
                  <TableCell>
                    <ChangeGochiKidUnlimitStatus
                      checked={
                        (shop.groupId &&
                          (shop.groupGochiKidUnlimit === 1 ||
                            (shop.groupGochiKidUnlimit === 0 &&
                              shop.gochiKidUnlimit === 1))) ||
                        (!shop.groupId && shop.gochiKidUnlimit === 1)
                      }
                      groupId={shop.groupId}
                      groupGochiKidUnlimit={shop.groupGochiKidUnlimit}
                      handeOpenSettingUnlimitGochiKidModal={() => {
                        handeOpenSettingUnlimitGochiKidModal(shop);
                      }}
                    />
                  </TableCell>
                )}
                {roles.isSecretariat && (
                  <TableCell>
                    <ChangeGochiKidReceipt
                      checked={
                        (shop.groupId &&
                          (shop.groupGochiKidReceipt === 1 ||
                            (shop.groupGochiKidReceipt === 0 &&
                              shop.shopDetail &&
                              shop.shopDetail.gochiKidReceipt === 1))) ||
                        (!shop.groupId &&
                          shop.shopDetail &&
                          shop.shopDetail.gochiKidReceipt === 1)
                      }
                      groupId={shop.groupId}
                      groupGochiKidReceipt={shop.groupGochiKidReceipt}
                      handeOpenSettingGochiKidReceiptModal={() => {
                        handeOpenSettingGochiKidReceiptModal(shop);
                      }}
                    />
                  </TableCell>
                )}
                {roles.isSecretariat && (
                  <TableCell>
                    <ChangeStatusShopShowTextButton
                      disabled={disabledShow}
                      shopId={shop.shopId}
                      titleStatus={titleShowStatus}
                      onClickAction={changeStatusShopShowAction}
                    />
                  </TableCell>
                )}
                {roles.isSecretariat && (
                  <TableCell>
                    <ChangeStatusShopTextButton
                      disabled={disabled}
                      titleStatus={titleStatus}
                      params={shopInfo}
                      onClickAction={changeStatusShopAction}
                      statusShop={statusShop}
                      setStatusShop={setStatusShop}
                      message={message}
                      setMessage={setMessage}
                    />
                  </TableCell>
                )}
                <TableCell style={{ textAlign: 'center' }}>
                  <ChangeAllowGapPayment
                    checked={shop.shopDetail.allowGapPayment}
                    handleAction={() => {
                      handleOpenChangeAllowGapPaymentModal(shop);
                    }}
                  />
                </TableCell>
                <TableCell>
                  <LinkPaypayButton
                    shopId={shop.shopId}
                    linkPaypayAction={linkPaypayAction}
                    linked={
                      shop.paymentTypes &&
                      shop.paymentTypes.find(
                        el => el.paymentType === paymentTypes.PAYPAY
                      ) &&
                      shop.paymentTypes.find(
                        el => el.paymentType === paymentTypes.PAYPAY
                      ).status === 1
                    }
                    unlinkPaypayAction={unlinkPaypayAction}
                  />
                </TableCell>
                {onePayEnabled && (
                  <TableCell>
                    <LinkOnePayButton
                      shopId={shop.shopId}
                      linkOnepayAction={linkOnepayAction}
                      linked={
                        shop.paymentTypes &&
                        shop.paymentTypes.find(
                          el => el.paymentType === paymentTypes.ONEPAY_ALIPAY
                        ) &&
                        shop.paymentTypes.find(
                          el => el.paymentType === paymentTypes.ONEPAY_ALIPAY
                        ).status === 1
                      }
                      unlinkOnepayAction={unlinkOnepayAction}
                    />
                  </TableCell>
                )}
                {wechatPayEnabled && (
                  <TableCell>
                    <LinkWechatPayButton
                      shopId={shop.shopId}
                      linkWechatPayAction={linkWechatPayAction}
                      linked={
                        shop.paymentTypes &&
                        shop.paymentTypes.find(
                          el => el.paymentType === paymentTypes.WECHATPAY
                        ) &&
                        shop.paymentTypes.find(
                          el => el.paymentType === paymentTypes.WECHATPAY
                        ).status === 1
                      }
                      unlinkWechatPayAction={unlinkWechatPayAction}
                    />
                  </TableCell>
                )}
                {roles.isSecretariat && (
                  <TableCell>
                    <LoginShopTextButton
                      cognitoUserId={shop.cognitoUserId}
                      shopName={shop.shopName}
                      shopId={shop.shopId}
                      groupEducateSystem={shop.groupEducateSystem}
                      onClickAction={loginToShop}
                    />
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(ShopTableBody);
